import React, { useState } from 'react';
import { format } from 'date-fns';
import { useMediaQuery, useTheme } from '@material-ui/core';
import clsx from 'clsx';

import useSanitizedHtml from 'hooks/useSanitizedHtml';
import styles from 'styles/components/gigs/GigDetails.module.scss';

const padding = {
  padding: '20px 15px',
};

const JobDescription = ({ gig, hasDate = false }) => {
  const [readMore, setReadMore] = useState(true);
  const toggleReadMore = () => setReadMore(prev => !prev);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const description = gig.guaranteed_gains ? gig.description.replace('1 ', '') : gig.description;
  const content =
    readMore && description.length > textLength
      ? description.replaceAll('\n', '<br />').slice(0, textLength)
      : description.replaceAll('\n', '<br />');

  const sanitizedHtml = useSanitizedHtml(content);

  const textLength = isMobile ? 300 : 500;

  return (
    <div style={padding}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3 className={styles.heading}>Description</h3>

        {hasDate && (
          <span style={{ fontSize: 13, color: '#9f9ead' }}>
            Created: {format(new Date(gig.created_at), 'MM/dd/yy')}
          </span>
        )}
      </div>

      <p
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
      />

      {description.length > textLength && (
        <strong onClick={toggleReadMore} className={clsx(styles.strong, 'color-main')}>
          {readMore ? ' ...read more' : ' show less'}
        </strong>
      )}
    </div>
  );
};

export default JobDescription;
